import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define a type for the slice state
interface DevState {
  isLoggedIn: boolean;
  userToken: string;
  sessionToken: string;
  isOnline: boolean;
}

// Define the initial state using that type
const initialState: DevState = {
  isLoggedIn: false,
  userToken: '',
  sessionToken: '',
  isOnline: navigator.onLine,
};

export const devSlice = createSlice({
  name: 'devSlice',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setOnlineStatus(state, action: PayloadAction<boolean>) {
      state.isOnline = action.payload;
    },
  },
});

export const { setOnlineStatus } = devSlice.actions;

export default devSlice.reducer;
